import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Youtube = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M19.6 7a.81.81 0 0 0-.53-.6C18.63 6.28 16.5 6 12 6s-6.63.28-7.07.4a.81.81 0 0 0-.54.6C4.3 7.42 4 9.2 4 12a25 25 0 0 0 .4 5c.07.3.29.53.53.6.44.12 2.57.4 7.07.4s6.63-.28 7.07-.4c.24-.07.46-.3.54-.6.1-.42.39-2.2.39-5s-.29-4.58-.4-5Zm1.94-.5C22 8.28 22 12 22 12s0 3.72-.46 5.5c-.25.99-1 1.76-1.93 2.02C17.9 20 12 20 12 20s-5.9 0-7.6-.48a2.81 2.81 0 0 1-1.94-2.02C2 15.72 2 12 2 12s0-3.72.46-5.5c.25-.99 1-1.76 1.93-2.02C6.11 4 12 4 12 4s5.9 0 7.6.48a2.81 2.81 0 0 1 1.94 2.02ZM10 15.5v-7l6 3.5-6 3.5Z"
    />
  </svg>
));
